var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 134,
    viewBox: "0 0 135 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_48_9127)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.1402,
    cy: 66.8259,
    rx: 47.1402,
    ry: 46.8259,
    fill: "#527BFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_48_9127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7553 81.1117C103.487 81.1117 103.487 76.3834 103.487 76.3834C103.487 76.3834 103.487 71.655 98.7553 71.655C94.0234 71.655 94.0234 73.772 94.0234 76.3834C94.0234 78.9947 94.0234 81.1117 98.7553 81.1117Z",
    fill: "#9AB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4313 70.3039C104.839 70.3039 104.839 64.9001 104.839 64.9001C104.839 64.9001 104.839 59.4963 99.4313 59.4963C94.0234 59.4963 94.0234 61.9157 94.0234 64.9001C94.0234 67.8846 94.0234 70.3039 99.4313 70.3039Z",
    fill: "#819FFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_48_9127)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_48_9127)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1267 45C94.2779 45 99.0057 49.6669 99.0057 56.6673V63.6677C99.0057 66.6344 97.7829 69.6012 95.6405 71.8006C97.5892 72.9674 99.0057 74.8793 99.0057 76.7911C99.0057 82.9164 94.159 87 86.889 87H41.969C38.9398 87 38.334 86.4895 38.334 83.9373V75.335V70.6658V57.834C38.334 50.8337 44.2735 45 51.5435 45H87.1267Z",
    fill: "#CDD9FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_48_9127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.4298 74.6057H57.0777C54.6692 74.6057 54.6689 75.1891 54.6689 76.3558C54.6689 77.5225 55.8733 79.2726 63.0998 79.2726H82.4078C89.6342 79.2726 90.8386 77.5225 90.8386 76.3558C90.8386 75.1891 90.8384 74.6057 88.4298 74.6057Z",
    fill: "#FF8F5C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_48_9127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.473 48.583H88.2003C93.1716 48.583 96.0885 52.6666 96.0885 57.1767V60.9258C96.0885 65.1887 92.0048 69.5841 87.0335 69.5841H58.473C53.2723 69.5841 49.418 66.3554 49.418 62.0925V57.1767C49.418 51.7471 53.2723 48.583 58.473 48.583Z",
    fill: "#527BFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_48_9127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1483 66.4661C67.6382 66.4661 71.278 63.0707 71.278 58.8823C71.278 54.6939 67.6382 51.2986 63.1483 51.2986C58.6584 51.2986 55.0186 54.6939 55.0186 58.8823C55.0186 63.0707 58.6584 66.4661 63.1483 66.4661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3289 66.4661C89.8188 66.4661 93.4586 63.0707 93.4586 58.8823C93.4586 54.6939 89.8188 51.2986 85.3289 51.2986C80.839 51.2986 77.1992 54.6939 77.1992 58.8823C77.1992 63.0707 80.839 66.4661 85.3289 66.4661Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_48_9127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0834 81.1114C39.8153 81.1114 39.8153 78.9945 39.8153 76.3831C39.8153 73.7717 39.8153 71.6548 35.0834 71.6548C30.3516 71.6548 30.3516 76.3831 30.3516 76.3831C30.3516 76.3831 30.3516 81.1114 35.0834 81.1114Z",
    fill: "#9AB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4079 70.3039C39.8157 70.3039 39.8157 67.8846 39.8157 64.9001V64.9001C39.8157 61.9157 39.8157 59.4963 34.4079 59.4963C29 59.4963 29 64.9001 29 64.9001C29 64.9001 29 70.3039 34.4079 70.3039Z",
    fill: "#819FFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_48_9127",
    x: 0,
    y: 0,
    width: 134.28,
    height: 133.652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_9127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_9127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_48_9127",
    x: 92.0234,
    y: 59.4963,
    width: 12.8154,
    height: 25.6152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_9127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_9127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_48_9127",
    x: 36.334,
    y: 45,
    width: 62.6719,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_9127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_9127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_48_9127",
    x: 33.334,
    y: 42,
    width: 68.6719,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_9127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_9127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_48_9127",
    x: 54.6689,
    y: 74.6057,
    width: 36.1699,
    height: 5.66699,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "shape",
    result: "effect1_innerShadow_48_9127"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_48_9127",
    x: 47.418,
    y: 44.583,
    width: 52.6709,
    height: 27.0012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.72 0 0 0 0 0.786316 0 0 0 0 1 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-lighter",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_9127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_9127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_48_9127",
    x: 53.0186,
    y: 49.2986,
    width: 42.4404,
    height: 19.1675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_9127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_9127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_48_9127",
    x: 27,
    y: 59.4963,
    width: 12.8154,
    height: 25.615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_9127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_9127",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.a6ac9c67483f682c0abc99f36c5246cf.svg";
export { ForwardRef as ReactComponent };